import * as React from "react"

const KtpPass = (props) => (
  <svg
    width={161}
    height={106}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#a)">
      <rect x={6} y={13} width={143} height={83.294} rx={4} fill="#fff" />
      <rect
        x={36.222}
        y={23.32}
        width={86.979}
        height={4.423}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={36.222}
        y={30.691}
        width={86.979}
        height={8.108}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={13.371}
        y={49.118}
        width={27.273}
        height={9.582}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={13.371}
        y={64.598}
        width={27.273}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={13.371}
        y={73.443}
        width={27.273}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={13.371}
        y={82.289}
        width={27.273}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={45.804}
        y={49.118}
        width={58.232}
        height={9.582}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={45.804}
        y={64.598}
        width={58.232}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={45.804}
        y={73.443}
        width={58.232}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={45.804}
        y={82.289}
        width={58.232}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <path
        d="M136.03 78c-3.383-1.338-4.464-2.467-4.464-4.885 0-1.451 1.108-2.392 1.486-3.636.378-1.243.597-2.716.778-3.787.182-1.071.254-1.485.353-2.627.121-1.424-.757-5.101-5.453-5.101-4.695 0-5.576 3.677-5.453 5.101.099 1.142.172 1.556.353 2.627.181 1.071.398 2.544.775 3.787.378 1.244 1.488 2.185 1.488 3.636 0 2.418-1.081 3.547-4.464 4.885-3.395 1.341-5.599 2.663-5.599 3.598v4.376h25.799v-4.376c0-.933-2.205-2.255-5.599-3.598Z"
        fill="#8499A9"
      />
    </g>
    <rect x={136} width={25} height={26} rx={12.5} fill="#5675D3" />
    <path
      d="M145 7h7v3.6l-2.333 2.4L152 15.4V19h-7v-3.6l2.333-2.4L145 10.6V7Zm5.833 8.7-2.333-2.4-2.333 2.4v2.1h4.666v-2.1Zm-2.333-3 2.333-2.4V8.2h-4.666v2.1l2.333 2.4Zm-1.167-3.3h2.334v.45l-1.167 1.2-1.167-1.2V9.4Z"
      fill="#fff"
    />
    <defs>
      <filter
        id="a"
        x={0}
        y={10}
        width={155}
        height={95.294}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.239688 0 0 0 0 0.310242 0 0 0 0 0.491667 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_942_6398"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_942_6398"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export default KtpPass
